import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { Enum } from "../../../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { Column } from "../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { ItemTemplate } from "../../../../../UI.Controls/DataGridSubcontrols/Templates/ItemTemplate";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { EnumEditTemplate } from "./Templates/EnumEditTemplate";

export class EnumColumn extends Column {
    //#region Fields
    private _enumName: string;
    //#endregion

    public get enumName(): string {
        if (!this._enumName) {
            const en = this.fullDataType.split("|");
            if (en.length > 1)
                this._enumName = en[1];
        }
        return this._enumName;
    }

    public set enumName(v: string) {
        this._enumName = v;
    }

    protected static override get observedAttributes(): string[] {
        return ["enumname"].concat(Column.observedAttributes);
    }
    //#region Methods

    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array)
            return "";

        const val = AttrValueReader.read(data);
        if (!(val instanceof Enum))
            return "";

        return await val.getLocalizedName();
    }

    //#endregion Methods

    //#region HTMLElement
    protected override _constructor(): void {
        super._constructor();

        this.itemTemplate = new ItemTemplate();
        this.editItemTemplate = new EnumEditTemplate();
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        if (attrName == "enumname") {
            this.enumName = newVal;
        }
    }
    //#endregion HTMLElement

    public override dispose(): void {
        super.dispose();
    }
} //end Column

registerCustomElement("tsc-xgenumcolumn", EnumColumn);
